/* global __THREEKIT_AUTH_TOKEN__ */

import { initPlayer } from './initPlayer';
import { getInitialConfiguration } from './persistence';
import publicApi from './api';
import { addCapacityListener } from './items';

import { THREEKIT_AUTH_TOKEN } from '../../threekitEnv';

const getAsset = (productCategory) => {
  switch (productCategory) {
    case 'sac':
      return {
        assetId: 'deff3063-b303-4273-bf9d-d87cdbc912dd',
        // stageId: '4fca7e4c-5b3a-47c4-b883-7dcfc3445d48',
      };
    case 'squattoman':
    case 'throwPillow':
      return {
        assetId: '73c831bf-d3e1-4ebc-aaf9-ea4c790505a9',
      };
    case 'sactionalCovers':
      return {
        assetId: '6d4d2200-ee9e-4454-81c0-53495d7872d2',
      };
    // Sactional
    case 'outdoorSactional':
      return {
        assetId: '773c2524-057e-4776-b28e-86828d4df852',
      };
    case 'indoorSactional':
    default:
      return {
        assetId: 'e818aa0c-867f-4842-829c-05f6a4e91cb7',
      };
  }
};

export async function init(params) {
  console.log('Threekit: configurator init start');
  const {
    el,
    onCapacityChange,
    productCategory,
    analyticsCustomId,
    imageFitMode,
  } = params;
  // TODO: Clear or reuse any previous configurator

  const initialConfiguration = await getInitialConfiguration(params);
  const { assetId, stageId } = getAsset(productCategory);

  const playerApi = await initPlayer(
    el,
    THREEKIT_AUTH_TOKEN,
    assetId,
    stageId,
    initialConfiguration,
    { analyticsCustomId, imageFitMode }
  );

  // window.threekit.api = playerApi;
  // window.threekit.configurator = publicApi;

  if (onCapacityChange) addCapacityListener(onCapacityChange, true);

  console.log('Threekit: configurator init complete');
  return playerApi;
}
